import { Color } from '../../../enums/color'
import { IconName } from '../../Icon'
import { NotificationVariant } from '../types/variant'

interface NotificationStyles {
  color: Color
  bgColor: Color
  icon: IconName
}

export const variantStyles: Record<NotificationVariant, NotificationStyles> = {
  error: {
    color: Color.Grey950,
    bgColor: Color.Red100,
    icon: 'circleAlert',
  },
  warning: {
    color: Color.Grey950,
    bgColor: Color.Yellow100,
    icon: 'circleAlert',
  },
  info: {
    color: Color.Grey950,
    bgColor: Color.Lavender100,
    icon: 'info',
  },
  success: {
    color: Color.Grey950,
    bgColor: Color.Green100,
    icon: 'circleCheck',
  },
}
